export class Apointment {
  public _id: string;
  public title: string;
  public customer: any;
  public date: any;
}



// WEBPACK FOOTER //
// ./src/app/models/apointment.model.ts